import React, { Component } from 'react';
import { withStyles } from 'tss-react/mui';
import { Box } from '@mui/material';
import { DCERT } from '@lba-dev/package.local-globals/docTypes';
import { DOCVAL } from '@lba-dev/package.local-globals/docStatus';

import FullscreenFileDialog from '../Dialogs/FullscreenFileDialog';
import DocsRowItem from '../Utils/DocsRowItem';
import api from '../../api';
import notifSystem from '../../notifSystem';

const styles = {
  container: {
    overflowX: 'hidden',
    overflowY: 'auto',
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
};

class DocsList extends Component {
  state = {
    dialogData: null
  }

  container = React.createRef()

  setDialogData = (dialogData = null) => this.setState({ dialogData })

  sendStatus = ({
    fileName,
    status,
    endDate,
  }, onComplete) => {
    const { id, type, collection, certificatType } = this.props;

    // Si c'est un certificat d'intervention
    if (
      collection === 'interventions' &&
      certificatType &&
      type === DCERT
    ) {
      const endpoint = status === DOCVAL
        ? `${id}/certificat/${certificatType}/validate`
        : `${id}/certificat/${certificatType}/reject`;

      api.interventions.custom(endpoint)
        .patch({ fileName })
        .then(() => {
          if (this.props.getFile) {
            this.props.getFile();
          }
          notifSystem.success('Opération réussi',
            'Le certificat a été mis à jour');
          onComplete();
        })
        .catch(() => {
          notifSystem.error('Opération échoué',
            'Le certificat n\'a pas pu être mis à jour');
          onComplete();
        });
    } else {
      // Documents merge (comportement existant)
      const payload = { status, fileName, type };

      if (endDate) {
        payload.endDate = endDate;
      }

      api.artisans.custom(`changeDocStatus/${id}`)
        .post(payload)
        .then(() => {
          if (this.props.getFile) {
            this.props.getFile();
          }
          notifSystem.success('Opération réussi',
            'Le status a bien été mis à jour');
          onComplete();
        })
        .catch(() => {
          notifSystem.error('Opération échoué',
            'Le status n\'a pas pu être mis à jour');
          onComplete();
        });
    }
  };

  requestAnalysis = (fileName, onComplete) => {
    const { id, type, certificatType } = this.props;
    api.dropbox.custom('reanalyze')
      .post({ id, fileName, type, certificatType })
      .then(() => {
        if (this.props.getFile) {
          this.props.getFile();
        }
        onComplete();
        notifSystem.success('Analyse terminée',
          'Le document a été analysé avec succès');
      })
      .catch((error) => {
        if (this.props.getFile) {
          this.props.getFile();
        }
        onComplete();
        const message = error?.body?.message || 'L\'analyse a échoué';
        notifSystem.error('Erreur d\'analyse', message);
      });
  };

  render() {
    const { dialogData } = this.state;

    const {
      data,
      handleDelete,
      selectedElems = [],
      isSelected,
      id,
      classes,
      users = [],
      ...props
    } = this.props;

    return (
      <div ref={this.container}>
        <Box className={classes.container} {...props}>
          {[...data].reverse().map((elem, i) => (
            <DocsRowItem
              sendStatus={this.sendStatus}
              requestAnalysis={this.requestAnalysis}
              key={`${elem.fileName}-${elem.link}`}
              name={elem.fileName}
              content={elem.link}
              status={elem.status}
              addedBy={elem.addedBy}
              userId={elem.userId}
              isExpired={elem.isExpired}
              users={users}
              id={id}
              selected={
                typeof isSelected === 'function'
                  ? isSelected(elem, i)
                  : selectedElems.includes(elem.fileName)
              }
              handleDelete={handleDelete && (() => handleDelete(elem, i))}
              handleClick={() => this.setDialogData(elem)}
              metadata={elem.metadata}
              analysisError={elem.analysisError}
              type={elem.type}
              endDate={elem.endDate}
              date={elem.date}
            />
          ))}
        </Box>
        {!!dialogData && (
          <FullscreenFileDialog
            file={{ name: dialogData.fileName, url: dialogData.link }}
            close={() => this.setDialogData()}
          />
        )}
      </div>
    );
  }
}

export default withStyles(DocsList, styles);
